<!-- Component that shows dynamic content -->
<template lang="html">
  <v-content>
    <app-loading-dialog></app-loading-dialog>
    <router-view></router-view>
  </v-content>
</template>

<script>
  import AppLoadingDialog from '@/components/app-layouts/app-loading-dialog/loading'

  export default {
    components: { 'app-loading-dialog': AppLoadingDialog }
  }
</script>

<style lang="css">
  main {
    margin-top: 1em;
  }
</style>



// WEBPACK FOOTER //
// content.vue?6e4db650